var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ManuelContent',{attrs:{"src":"/MANUEL_ADMIN.md"}})
}
var staticRenderFns = []

export { render, staticRenderFns }